import { Box } from "@mui/material";
import Card from "components/Cards/Card";
import EditCreateHeaderCard from "components/Cards/EditCreateHeaderCard";
import useForms from "helpers/hooks/useForms";
import DashboardLayout from "pages/layouts/dashboard";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import JobDetails from "./JobDetails";
import { useLocalizedTranslation } from "helpers/hooks/useLocalizedTranslation";
import { schema } from "./data";
import CreateFormFooter from "components/UI/atoms/CreateFormFooter";
import {
  deleteValues,
  keyVal,
  payloadKeyVal,
  payloadKeyVals,
  payloadToArrayKeyValues,
} from "helpers/utils/utilities";
import useJobNetwork from "store/job-network";

const initData = {
  compensation_country_type: "CAD",
};

const JobCreateEditPage = () => {
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const editMode = !!id;
  const [initLoading, setInitLoading] = useState(Boolean(editMode));
  const { t } = useLocalizedTranslation();
  const { create, fetchJob, edit } = useJobNetwork();
  const { data, errors, validate, onChange, setData } = useForms(
    schema,
    initData
  );

  useEffect(() => {
    if (editMode) handleFetchDetails();
    else setData(initData);
  }, [editMode]);

  const handleFetchDetails = async () => {
    setInitLoading(true);
    const res = await fetchJob(id);
    const {
      compensation_country_type,
      application_deadline,
      compensation,
      compensation_type_id,
      compensation_type,
      description,
      experience_level_id,
      experience_level,
      hours,
      address,
      job_type_id,
      job_type,
      openings,
      organization,
      organization_id,
      organization_slug,
      payment_frequency,
      skills,
      status,
      title,
      uuid,
      work_mode,
    } = res;
    setData({
      compensation_country_type,
      application_deadline,
      compensation,
      description,
      hours,
      compensation_type_id: keyVal(compensation_type, compensation_type_id),
      experience_level_id: keyVal(experience_level, experience_level_id),
      address,
      job_type_id: keyVal(job_type, job_type_id),
      openings,
      organization,
      organization_id,
      organization_slug,
      payment_frequency,
      skills: payloadToArrayKeyValues(skills),
      status,
      title,
      uuid,
      work_mode,
    });
    setInitLoading(false);
  };

  const onSubmit = async () => {
    const _errors = await validate();
    if (_errors.size) return;
    setLoading(true);
    const payload = {
      ...data,
      city: data?.address?.city,
      location: data?.address?.address_1,
      longitude: (data?.address?.longitude || "").toString(),
      latitude: (data?.address?.latitude || "").toString(),
      country: data?.address?.country,
      state: data?.address?.state,
    };

    payloadKeyVal(payload, [
      "compensation_type_id",
      "experience_level_id",
      "job_type_id",
    ]);
    payloadKeyVals(payload, ["skills"]);

    const toDelete = ["address"];

    deleteValues(payload, toDelete);
    editMode ? await edit(id, payload) : await create(payload);
    setLoading(false);
  };

  return (
    <DashboardLayout isPrivate loading={initLoading}>
      <Box className="w-full">
        <EditCreateHeaderCard
          title={`${editMode ? "EDIT YOUR" : "CREATE A"} JOB`}
          classes="mt-header"
        />
        <Card classes="my-5 container" width="min(1300px,90%)" centered>
          <JobDetails t={t} data={data} errors={errors} onChange={onChange} />
          <CreateFormFooter
            stepsLength={1}
            onCancel={() => {}}
            disabled={!!errors.size || loading}
            loading={loading}
            onOk={onSubmit}
            editMode={editMode}
            okButtonColor="blue"
            backButtonColor="red"
            cancelButtonTitle="Discard"
            confirmationOkBtnTitle="Exit Now"
            okButtonTitle={editMode ? "Save" : "Create Job"}
            step={step}
          />
        </Card>
      </Box>
    </DashboardLayout>
  );
};

export default JobCreateEditPage;
